import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function SettingsForAccountRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.SettingsForAccount', {
		url: '/admin/settings/account',
		controllerAs: 'vm',
		controller: SettingsForAccountCtrl,
		templateUrl: '/ng/hub/Settings/ForAccount/SettingsForAccountCtrl.html?' + window.BUILD,
		permission: ['manage_hubs'],
		resolve: {
			$title: () => 'Account Settings',
			settings: ApiResourcify.endpoint('/config/search?scopes=account'),
		},
	});
}

export class SettingsForAccountCtrl {
	constructor(settings) {
		'ngInject';
		this.settings = settings;
	}
}
